/**
 * Within the `template`, replace placeholders with `values`, where each `key` when denoted as `{{key}}` is replaced with its corresponding `value`.
 * Supports spaces around the name of the `key`, but it's recommended to avoid them for consistency; i.e. `{{ key }}` is valid, but `{{key}}` is preferred.
 * Loosely based on the mustache template syntax from [Handlebars](https://handlebarsjs.com/) or [Mustache](https://mustache.github.io/).
 *
 * Additionally supports both `key` and `{{key}}` formats in the `values` object for compatibility, but if both are present with different values, it will prefer the `key` format.
 * This is to allow for easier integration with existing code that may have used the `{{key}}` format in the `values` object, but it's recommended to use the `key` format for consistency and to avoid confusion.
 *
 * This will NOT support allowing `values` objects that have whitespace in the key, as that is an anti-pattern and developers are expected to use one format consistently, as is supported through the union type on known literal `text`.
 *
 * @example
 * template('Hello {{name}}', { name: 'World' }) // returns 'Hello World'
 */
// ? should this have an overload to support loose/partial template values // -> no, enforce always with type, then the caller decide what to do
export function template(text, values) {
    return text.replace(/{{\s*(.*?)\s*}}/g, (_, key) => {
        const keyWithBraces = `{{${key}}}`;
        const braceValue = keyWithBraces in values
            ? values[keyWithBraces]
            : null;
        const plainValue = key in values ? values[key] : null;
        if (braceValue !== null &&
            plainValue !== null &&
            braceValue !== plainValue) {
            // TODO consider a better way to warn/error
            // oxlint-disable-next-line no-console
            console.warn(`Warning: Conflicting values for key "${key}" in template: "${plainValue}" and "${braceValue}". Using "${plainValue}". Consider removing the duplicate key "${keyWithBraces}" from the values object to avoid confusion.`);
        }
        return plainValue ?? braceValue ?? keyWithBraces;
    });
}
//# sourceMappingURL=template.js.map